<img [src]="img" class="long-heading-img" [alt]="alt">
<app-css-glitch [text]="text" class="app-css-glitch"></app-css-glitch>